import CommonActions from "../actions/CommonActions";
import {ACCOUNT_MENU_ITEM_ID} from "../components/AccountComponent/Constants";

const LoginComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/LoginComponent"));
const LogoComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/LogoComponent"));
const RegionalComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/RegionalComponent"));
const LocaleComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/LocaleComponent"));
const NavigationComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/NavigationComponent"));
const NavigationWhitelabelComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/NavigationWhitelabelComponent"));
const Announcements = CommonActions.lazyWithPreload(() => import( "../components/Announcements"));
const SwitchModeComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/SwitchModeComponent"));
const SettingsComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/SettingsComponent"));
// const MenuAuth = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/MenuAuth"));
// const CopyrightComponent = CommonActions.lazyWithPreload(() => import( "../components/FooterComponent/CopyrightComponent"));
// const AboveFooterComponent = CommonActions.lazyWithPreload(() => import( "../components/FooterComponent/AboveFooterComponent"));
// const ContentFooterComponent = CommonActions.lazyWithPreload(() => import( "../components/FooterComponent/ContentFooterComponent"));
// const MenuFooterComponent = CommonActions.lazyWithPreload(() => import( "../components/FooterComponent/MenuFooterComponent"));
const BannerScrollBarComponent = CommonActions.lazyWithPreload(() => import( "../components/BannerScrollBarComponent"));
const ClassicBetslipComponent = CommonActions.lazyWithPreload(() => import( "../components/ClassicBetslipComponent"));
const ClassicSportMenuComponent = CommonActions.lazyWithPreload(() => import( "../components/ClassicSportMenuComponent"));
const ClassicViewOptionComponent = CommonActions.lazyWithPreload(() => import( "../components/ClassicViewOptionComponent"));
const ClassicSportMarketComponent = CommonActions.lazyWithPreload(() => import( "../components/ClassicSportMarketComponent"));
const ClassicOddPageComponent = CommonActions.lazyWithPreload(() => import( "../components/ClassicOddPageComponent"));
const ClassicLinesPageActionComponent = CommonActions.lazyWithPreload(() => import( "../components/ClassicLinesPageActionComponent"));
const HelpComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/HelpComponent"));
const ResultComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/ResultComponent"));
// const TimezoneComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/TimezoneComponent"));
const AccountMenuComponent = CommonActions.lazyWithPreload(() => import( "../components/HeaderComponent/SubComponents/AccountMenuComponent"));
const ClassicParlayBettingMenuComponent = CommonActions.lazyWithPreload(() => import( "../components/ClassicParlayBettingMenuComponent"));
const MaintenanceComponent = CommonActions.lazyWithPreload(() => import( "../components/MaintenanceComponent"));
const OddsPageComponent = CommonActions.lazyWithPreload(() => import( "../components/CompactView/OddsPageComponent"));
const FooterLinkComponent = CommonActions.lazyWithPreload(() => import( "../components/CompactView/FooterComponent/FooterLinkComponent"));
const FooterDisclaimerComponent = CommonActions.lazyWithPreload(() => import( "../components/CompactView/FooterComponent/FooterDisclaimerComponent"));
const CookieAndLicenseComponent = CommonActions.lazyWithPreload(() => import( "../components/CompactView/FooterComponent/CookieAndLicenseComponent"));
const BalanceComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/BalanceComponent"));
const LeftSideBarComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/LeftSideBarComponent"));
const ViewOptionsComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/ViewOptionsComponent"));
const LoginModalComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/LoginModalComponent"));
const FreshchatCompactComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/FreshchatCompactComponent"));
const VsPageComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/VsPageComponent"));
const SearchBoxComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/SearchBoxComponent"));
const SalesForceChatWigetComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/SalesForceChatWigetComponent"));
const BetBuilderComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/BetBuilderComponent/"));

const CasinoSliderComponent = CommonActions.lazyWithPreload(() => import("../components/CasinoComponent/CasinoSliderComponent"));
const LeftCasinoComponent = CommonActions.lazyWithPreload(() => import("../components/CasinoComponent/LeftCasinoComponent"));
const LeftLiveCasinoComponent = CommonActions.lazyWithPreload(() => import("../components/LiveCasinoComponent/LeftLiveCasinoComponent"));
const RightCasinoComponent = CommonActions.lazyWithPreload(() => import("../components/CasinoComponent/RightCasinoComponent"));
const CasinoGameWindowComponent = CommonActions.lazyWithPreload(() => import("../components/CasinoComponent/CasinoGameWindowComponent"));
const LiveCasinoGameWindowComponent = CommonActions.lazyWithPreload(() => import("../components/LiveCasinoComponent/LiveCasinoGameWindowComponent"));
const RequiredLoginComponent = CommonActions.lazyWithPreload(() => import("../components/RequiredLoginComponent"));
const CasinoFilterBarMainCategoryComponent = CommonActions.lazyWithPreload(() => import("../components/CasinoComponent/CasinoFilterBarMainCategoryComponent"));
const LiveCasinoSliderComponent = CommonActions.lazyWithPreload(() => import("../components/LiveCasinoComponent/LiveCasinoSliderComponent"));

const ChangePasswordPageComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/ChangePasswordPageComponent"));
const AccountSideBarComponent = CommonActions.lazyWithPreload(() => import("../components/AccountComponent/AccountSideBarComponent"));
const PersonalDetailsComponent = CommonActions.lazyWithPreload(() => import("../components/AccountComponent/ProfileComponent"));
const PasswordSecurityComponent = CommonActions.lazyWithPreload(() => import("../components/AccountComponent/PasswordSecurityComponent"));
export const PasswordSecurityTab = CommonActions.lazyWithPreload(() => import('../components/AccountComponent/PasswordSecurityComponent/PasswordSecurity'));
export const LastLogin = CommonActions.lazyWithPreload(() => import('../components/AccountComponent/PasswordSecurityComponent/LastLogin'));
const AccountRightComponent = CommonActions.lazyWithPreload(() => import("../components/AccountComponent/AccountRightComponent"));
const AnnouncementRightSideComponent = CommonActions.lazyWithPreload(() => import("../components/AccountComponent/AnnouncementRightSideComponent"));
const AccountMenuContentComponent = CommonActions.lazyWithPreload(() => import( "../components/AccountComponent/AccountMenuContentComponent"));
const LandingPageComponent = CommonActions.lazyWithPreload(() => import( "../components/LandingPageComponent"));
const ActiveLinkComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/ActiveLinkComponent"));
const OddsDelayBannerComponent = CommonActions.lazyWithPreload(() => import("../components/CompactView/OddsDelayBannerComponent"));
const PrestigeClubComponent = CommonActions.lazyWithPreload(() => import( '../components/PrestigeClubComponent'));
const LoginMessageComponent = CommonActions.lazyWithPreload(() => import( '../components/CompactView/LoginMessageComponent'));
const AuthenticatorMobileModal = CommonActions.lazyWithPreload(() => import( '../components/AccountComponent/PasswordSecurityComponent/MultiFactorAuthenticationComponent/AuthenticatorMobileModal'));

 const ATATransferComponent = CommonActions.lazyWithPreload(() =>
     import("../components/AccountComponent/ATATransferComponent")
 );

const PreferencesComponent = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/PreferencesComponent")
);

const AccountMessagesInboxComponent = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/AccountMessagesInboxComponent")
);
const SelfExclusionLimitsComponent = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/SelfExclusionLimitsComponent")
);
const profile = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/ProfileComponent")
);
const StatementsComponent = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/StatementsComponent")
);
const BettingHistoryComponent = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/BettingHistoryComponent")
);
const PassWordSecurity = CommonActions.lazyWithPreload(() =>
 import("../components/AccountComponent/PasswordSecurityComponent")
);
const CashierDeposit = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/CashierComponent/CashierDepositComponent")
);
const CashierWithdrawal = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/CashierComponent/CashierWithdrawalComponent")
);
const CashierMyPaymentAccount = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/CashierComponent/CashierMyPaymentAccountComponent")
);
const CashierTransactionHistory = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/CashierComponent/CashierTransactionHistoryComponent")
);
const MyBonusComponent = CommonActions.lazyWithPreload(() =>
    import("../components/AccountComponent/CashierComponent/MyBonusComponent")
);
const UnifiedAccountComponentsMapping = {
    'statements': StatementsComponent,
    [ACCOUNT_MENU_ITEM_ID.STATEMENTS]: StatementsComponent,
    [ACCOUNT_MENU_ITEM_ID.BETTING_HISTORY]: BettingHistoryComponent,
    [ACCOUNT_MENU_ITEM_ID.ATA_TRANSFERS]: ATATransferComponent,
    [ACCOUNT_MENU_ITEM_ID.PREFERENCES]: PreferencesComponent,
    [ACCOUNT_MENU_ITEM_ID.INBOX]: AccountMessagesInboxComponent,
    [ACCOUNT_MENU_ITEM_ID.ANNOUNCEMENTS]: AccountMessagesInboxComponent,
    [ACCOUNT_MENU_ITEM_ID.SELF_EXCLUSION_LIMIT]: SelfExclusionLimitsComponent,
    [ACCOUNT_MENU_ITEM_ID.PERSONAL_DETAILS]: profile,
    [ACCOUNT_MENU_ITEM_ID.PASSWORD_SECURITY]: PassWordSecurity,
    [ACCOUNT_MENU_ITEM_ID.DEPOSIT]: CashierDeposit,
    [ACCOUNT_MENU_ITEM_ID.WITHDRAWAL]: CashierWithdrawal,
    [ACCOUNT_MENU_ITEM_ID.TRANSACTIONS]: CashierTransactionHistory,
    [ACCOUNT_MENU_ITEM_ID.PAYMENT_ACCOUNTS]: CashierMyPaymentAccount,
    [ACCOUNT_MENU_ITEM_ID.MY_BONUS]: MyBonusComponent
};

const PromotionsComponent = CommonActions.lazyWithPreload(() =>
    import("../components/PromotionsComponent/")
);

const PromotionSurveyComponent = CommonActions.lazyWithPreload(() =>
    import("../components/PromotionsComponent/PromotionSurveyComponent/")
);

const LeaderboardComponent = CommonActions.lazyWithPreload(() =>
  import("../components/LeaderboardComponent")
);

const ComponentKeyMappings = {
    ...UnifiedAccountComponentsMapping,
    "HelpComponent": HelpComponent,
    "RegionalComponent": RegionalComponent,
    "SwitchModeComponent": SwitchModeComponent,
    "Announcements": Announcements,
    "AccountMenuComponent": AccountMenuComponent,
    "LoginComponent": LoginComponent,
    "LogoComponent": LogoComponent,
    "NavigationComponent": NavigationComponent,
    "ScrollNavigationComponent": NavigationComponent,
    "NavigationWhitelabelComponent": NavigationWhitelabelComponent,
    "LocaleComponent": LocaleComponent,
    "ResultComponent" : ResultComponent,
    "SettingsComponent" : SettingsComponent,
    "BannerScrollBarComponent": BannerScrollBarComponent,
    "ClassicBetslipComponent": ClassicBetslipComponent,
    "ClassicSportMenuComponent": ClassicSportMenuComponent,
    "ClassicViewOptionComponent": ClassicViewOptionComponent,
    "ClassicSportMarketComponent": ClassicSportMarketComponent,
    "ClassicOddPageComponent": ClassicOddPageComponent,
    "ClassicLinesPageActionComponent": ClassicLinesPageActionComponent,
    "ClassicParlayBettingMenuComponent": ClassicParlayBettingMenuComponent,
    "MaintenanceComponent": MaintenanceComponent,
    "OddsPageComponent": OddsPageComponent,
    "FooterLinkComponent": FooterLinkComponent,
    "FooterDisclaimerComponent": FooterDisclaimerComponent,
    "CookieAndLicenseComponent": CookieAndLicenseComponent,
    "BalanceComponent": BalanceComponent,
    "LeftSideBarComponent": LeftSideBarComponent,
    "ViewOptionsComponent": ViewOptionsComponent,
    "LoginModalComponent": LoginModalComponent,
    "FreshchatCompactComponent": FreshchatCompactComponent,
    "CasinoSliderComponent": CasinoSliderComponent,
    "LeftCasinoComponent": LeftCasinoComponent,
    "LeftLiveCasinoComponent": LeftLiveCasinoComponent,
    "RightCasinoComponent": RightCasinoComponent,
    "CasinoGameWindowComponent": CasinoGameWindowComponent,
    "LiveCasinoGameWindowComponent": LiveCasinoGameWindowComponent,
    "RequiredLoginComponent": RequiredLoginComponent,
    "CasinoFilterBarMainCategoryComponent": CasinoFilterBarMainCategoryComponent,
    "LiveCasinoSliderComponent": LiveCasinoSliderComponent,
    "VsPageComponent": VsPageComponent,
    "ChangePasswordPageComponent": ChangePasswordPageComponent,
    "AccountSideBarComponent": AccountSideBarComponent,
    "AccountMenuContentComponent": AccountMenuContentComponent,
    "LandingPageComponent": LandingPageComponent,
    "PersonalDetailsComponent": PersonalDetailsComponent,
    "PasswordSecurityComponent": PasswordSecurityComponent,
    "AccountRightComponent":AccountRightComponent,
    "AnnouncementRightSideComponent": AnnouncementRightSideComponent,
    "PromotionsComponent": PromotionsComponent,
    "PromotionSurveyComponent": PromotionSurveyComponent,
    "ActiveLinkComponent": ActiveLinkComponent,
    "SearchBoxComponent": SearchBoxComponent,
    "OddsDelayBannerComponent": OddsDelayBannerComponent,
    "SalesForceChatWigetComponent": SalesForceChatWigetComponent,
    "LeaderboardComponent": LeaderboardComponent,
    "BetBuilderComponent": BetBuilderComponent,
    "PrestigeClubComponent": PrestigeClubComponent,
    "LoginMessageComponent": LoginMessageComponent,
    "AuthenticatorMobileModal": AuthenticatorMobileModal
};

export default ComponentKeyMappings;


// WEBPACK FOOTER //
// ./src/app/common/ComponentKeyMappings.js